import React, { JSX, useEffect, useRef } from 'react';
import {
  Image,
  ImageField,
  LinkField,
  Text,
  RichText,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { observeInView } from 'src/hooks/observeInView';

type TimelineChildProps = {
  summary: RichTextField;
  image: ImageField;
  imageRight: boolean;
  date: string;
  location: string;
  heading: string;
  link: LinkField;
  linkType?: string;
  imgAlt?: string;
  marginSize: string;
  id: string;
  last: boolean;
};

const TimelineChild = (props: TimelineChildProps): JSX.Element => {
  const {
    summary,
    image,
    imageRight,
    date,
    location,
    heading,
    link,
    linkType,
    imgAlt,
    marginSize,
    id,
    last,
  } = props;

  const animRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!animRef.current) return;

    observeInView(animRef.current);
  }, []);

  return (
    <div
      className={classNames(
        'article-summary',
        imageRight == true ? 'img-right' : '',
        getMarginSize(marginSize)
      )}
      id={`article-summary-${id}`}
      ref={animRef}
    >
      {image && (
        <div className="summary-img inner-vertical-spacing list-fade-in-anim animated">
          <Image field={image} alt={imgAlt} />
        </div>
      )}
      <div className={classNames('line', last ? 'last' : '')}></div>
      <div className="summary-content inner-vertical-spacing list-fade-in-anim animated">
        <div className="summary-inner">
          <h3 className="date-and-location">
            {date && `${date}`} {location && <span> | </span>}{' '}
            {location && ` ${location}`}
          </h3>

          <Text
            className="summary-title osf-display-h3"
            tag="h3"
            field={{ value: heading }}
          />

          {summary && (
            <RichText
              tag="p"
              className="summary-description"
              field={summary}
            />
          )}
        </div>
        {link && link?.value?.text && (
          <a
            className={
              linkType == 'Primary'
                ? 'btn-primary'
                : linkType == 'Secondary'
                  ? 'btn-secondary'
                  : 'btn-tertiary'
            }
            href={link?.value?.href}
          >
            {link?.value?.text}
          </a>
        )}
      </div>
    </div>
  );
};

export default TimelineChild;
